export const togglePhoneCardHidden = (hidden: boolean) => {
  const phoneCard = document.getElementById('phone_card')

  if (!phoneCard) return false
  if (hidden) {
    phoneCard.classList.add('hidden')
  } else {
    phoneCard.classList.remove('hidden')
  }

  return null
}
